export default {
  main: {
    en: 'Main',
  },
  men: {
    en: 'Men',
  },
  women: {
    en: 'Women',
  },

  fineFragrance: {
    en: 'Fragrance',
  },
  perfumes: {
    en: 'Perfumes',
  },
  colognes: {
    en: 'Colognes',
  },
  recommendations: {
    en: 'Recommendations',
  },
  fragranceByState: {
    en: 'Fragrance by state',
  },
  collectionsWomen: {
    en: 'Collections for women',
  },
  collectionsMen: {
    en: 'Collections for men',
  },
  perfumeOfTheMonth: {
    en: 'Perfume of the month',
  },
  cologneOfTheMonth: {
    en: 'Cologne of the month',
  },
  extras: {
    en: 'Extras & Cases',
  },
  horoscope: {
    en: 'Fragrance horoscope',
  },
  fragranceFinder: {
    en: 'Fragrance finder',
  },
  skincare: {
    en: 'Skincare',
  },
  bodyLip: {
    en: 'Lip',
  },
  skincareEye: {
    en: 'Eye',
  },
  wellness: {
    en: 'Wellness',
  },
  goldCollection: {
    en: 'Gold Collection',
  },

  cleansers: {
    en: 'Cleansers',
  },
  masks: {
    en: 'Masks',
  },
  moisturizers: {
    en: 'Moisturizers',
  },
  treatments: {
    en: 'Treatments',
  },
  mens: {
    en: 'Men\'s',
  },

  personalCare: {
    en: 'Personal Care',
  },
  allPersonalCare: {
    en: 'All Personal Care',
  },
  bodyMoisturizers: {
    en: 'Body Moisturizers',
  },
  handCreams: {
    en: 'Hand Cream',
  },
  shower: {
    en: 'Shower',
  },
  bodyWash: {
    en: 'Body Wash',
  },

  candles: {
    en: 'Candles',
  },
  scentedCandles: {
    en: 'Scented candles',
  },

  allMakeup: {
    en: 'All makeup',
  },

  makeup: {
    en: 'Makeup',
  },
  palettes: {
    en: 'Makeup Palettes',
  },
  eye: {
    en: 'Eye',
  },
  lip: {
    en: 'Lip',
  },
  face: {
    en: 'Face',
  },
  cheek: {
    en: 'Cheek',
  },
  tools: {
    en: 'Tools',
  },

  fathersDay: {
    en: 'Bamboo charcoal',
  },

  gifts: {
    en: 'Gifts',
  },
  allGifts: {
    en: 'All Gifts',
  },
  giftCard: {
    en: 'Gift card',
  },
  giftSetsMen: {
    en: 'Gifts For Him',
  },
  giftSetsWomen: {
    en: 'Gifts For Her',
  },
  skincareSets: {
    en: 'Scentbird Gift Sets',
  },
  giftSubscription: {
    en: 'Gift subscription',
  },
  blog: {
    en: 'Blog',
  },

  allSkincare: {
    en: 'All skincare',
  },

  brands: {
    en: 'Brands',
  },
  collections: {
    en: 'Collections',
  },
  browseAll: {
    en: 'Browse all',
  },
  makeupCollections: {
    en: 'Makeup Collections',
  },
  ourFavorite: {
    en: 'Our favorite',
  },
  bestseller: {
    en: 'Bestseller',
  },
  naturalLipBalms: {
    en: 'Natural Lip Balms',
  },
  bodyScrubs: {
    en: 'Body Scrubs',
  },
  bodyWashes: {
    en: 'Body Wash & Shower Gels',
  },
  bodyLotionsOils: {
    en: 'Body Lotions & Body Oils',
  },
  giftCards: {
    en: 'Gift Cards',
  },
  collectionsForWomen: {
    en: 'Collections for women',
  },
  collectionsForMen: {
    en: 'Collections for men',
  },
  bambooCharcoalCollection: {
    en: 'Bamboo Charcoal Collection',
  },
}
